import { render, staticRenderFns } from "./ProjectSettingsDialog.vue?vue&type=template&id=0c6ac99d&"
import script from "./ProjectSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports